exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-card-list{-webkit-transform:translateY(105%);transform:translateY(105%)}.ps-card-list.ps-is-active{-webkit-transform:translateY(0);transform:translateY(0)}", ""]);

// exports
